import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Typography,
  Button,
} from '@mui/material';
import { useListDifferentProjectsQuery } from '../../../../../../graphql/generated/graphql';

import { useLoginState } from '../../../../../hooks/loginInfo';
import { setDifferentProjects, useProjectsState } from '../../../../../hooks/projectsInfo';
import { setAlertHrefReturn, useActionAlertState } from '../../../../../hooks/actions';
import { StatusProjects } from '../../../../../config/interfaces';

import ConfigProjectLayout from '../../../../../theme/templates/project/config';
import { UserTypes } from '../../../../../config/enums';
import config from '../../../../../config/config';
import Loading from '../../../../components/loading';
import StatusProjectsContent from '../../../../components/company/card-project/status-projects';

const { PER_PAGE_LIST } = config;

const ProjectsPage = () => {
  const navigate = useNavigate();
  const loginState = useLoginState();
  const projectsState = useProjectsState();
  const userType = loginState.user_type.get();
  const [hrefLogin] = useState(useActionAlertState().hrefReturn.get());


  useEffect(() => {
    if (hrefLogin !== '/') {
      setAlertHrefReturn('/');
      navigate(hrefLogin);
    }
  }, []);

  const { data: projects, loading, refetch } = useListDifferentProjectsQuery({
    variables: {
      user_type: userType,
      per_page: PER_PAGE_LIST,
    },
    fetchPolicy: 'network-only',
  });

  useEffect(() => {
    if (projects) {
      setDifferentProjects(projects as StatusProjects);
    }
  }, [loading, projects]);

  return (
    <>
      {loading ? <Loading /> : <ConfigProjectLayout>
        {userType === UserTypes.PRODUCER && (
          <Button
            type="submit"
            variant="contained"
            href="/project/new"
            sx={{
              float: 'right',
            }}
          >
            + Add Project
          </Button>
        )}
        <Typography
          component="h1"
          variant="h1"
          sx={{
            mb: 2,
            color: "#58595b",
            fontWeight: 500,
          }}
        >
          My Projects
        </Typography>
        <StatusProjectsContent name="IN REVIEW" projects={projectsState.review.get()?.results} refetch={refetch} />
        <StatusProjectsContent name="ONGOING" projects={projectsState.onGoing.get()?.results} refetch={refetch} />
        <StatusProjectsContent name="DONE" projects={projectsState.done.get()?.results} refetch={refetch} />
      </ConfigProjectLayout>
      }
    </>
  );
}

export default ProjectsPage;
